import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SearchType from '../searchType/SearchType';


class SearchTypes extends Component {
  getSearchTypeRadioButtons() {
    return this.props.listOfSearchTypes.map(type =>
      <SearchType
        key={type}
        changeSearchType={this.props.changeSearchType}
        isSelected={this.props.selectedSearchType === type}
        name={type}
      />
    )
  }

  render() {
    return (
      <div id="court_type_wrapper">
        <div className="form-item">
          <div className="form-radios">
            {this.getSearchTypeRadioButtons()}
          </div>
        </div>
        <div className="clear" />
      </div>
    )
  }
}

SearchTypes.propTypes = {
  listOfSearchTypes: PropTypes.array,
};

SearchTypes.defaultProps = {
  listOfSearchTypes: ['Bankruptcy', 'Civil', 'Criminal'],
};


export default SearchTypes;



/** WEBPACK FOOTER **
 ** ./src/components/search/FormElements/searchTypeRadioButtons/SearchTypes.js
 **/